export default __webpack_public_path__ + "static/media/message.09ddd2f8.mp3";